export default __webpack_public_path__ + "static/media/1133.78edadeb.png";